export default "__VITE_ASSET__CcL4McJp__"